import { IField } from "../interfaces/inputs/IField";

export const EmailFields: IField[] = [
  { name: "sender", type: "text", label: "Sender", size: {lg: 6}, position: 1 },
  { name: "senderemail", type: "text", label: "Sender Email", size: {lg: 6}, position: 2 },
  { name: "destination", type: "text", label: "Recipient", size: {lg: 6}, position: 3 },
  { name: "subject", type: "text", label: "Subject", size: {lg: 6}, position: 4 },
  { name: "message", type: "textarea", label: "Message", rows: 6, size: {lg: 12}, position: 5 },
].sort((a: IField, b: IField) => a.position - b.position);